import { Link } from "react-router-dom";
import { Wapper, ContainerList, ListMobile, MobileContent } from "./styled";
import Logo from "../../../assets/img/Langding/NewLogo.svg";
import React, { useState, useEffect } from "react";

const MenuLangding = () => {
  const [backgroundColor, setBackgroundColor] = useState("rgba(0,0,0,0)");
  const [ShowMenu, setShowMenu] = useState(false);

  useEffect(() => {
    function handleScroll() {
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      const newColor = scrollPosition > 500 ? "rgba(61, 72, 86, 0.4);" : `rgba(0,0,0,0)`;
      setBackgroundColor(newColor);
    }

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return (
    <Wapper BgColor={backgroundColor}>
      <Link to="/">
        <img src={Logo} alt="" />
      </Link>
      <ContainerList>
        {ListArr.map((item) => {
          return (
            <>
              {item.title === "JOIN NOW" || item.title === "News" ? (
                <a href={item.link} key={item.link} target="_blank">
                  <button>{item.title}</button>
                </a>
              ) : (
                <Link to={item.link} key={item.link}>
                  <button>{item.title}</button>
                </Link>
              )}
            </>
          );
        })}
      </ContainerList>
      <ListMobile ShowMenu={ShowMenu}>
        <button
          onClick={() => {
            setShowMenu(!ShowMenu);
          }}
        ></button>
        <MobileContent ShowMenu={ShowMenu}>
          {ListArr.map((item) => {
            return (
              <>
                {item.title === "JOIN NOW" || item.title === "News" ? (
                  <a
                    href={item.link}
                    key={item.link}
                    onClick={() => {
                      setShowMenu(false);
                    }}
                    target="_blank"
                  >
                    <button>{item.title}</button>
                  </a>
                ) : (
                  <Link
                    to={item.link}
                    key={item.link}
                    onClick={() => {
                      setShowMenu(false);
                    }}
                  >
                    <button>{item.title}</button>
                  </Link>
                )}
              </>
            );
          })}
        </MobileContent>
      </ListMobile>
    </Wapper>
  );
};
export default MenuLangding;

const ListArr = [
  {
    link: "/",
    title: "About",
  },
  {
    link: "/",
    title: "C-Footprint",
  },
  {
    link: "https://greenfoundation.info/",
    title: "News",
  },
  {
    link: "/",
    title: "Re-Fi",
  },
  {
    link: "https://app.greenfoundation.io/",
    title: "JOIN NOW",
  },
];
